const defaultColors = [
  '#0047ab',
  '#005bbd',
  '#006fcc',
  '#0083d9',
  '#0097e5',
  '#00aaef',
  '#00bdf7',
  '#5cd6ff',
  '#43c5fd',
  '#35b3fa',
  '#3aa1f3',
  '#4b8dea',
  '#5f77dc',
  '#7260ca',
  '#8246b3'
];

const progressColors = [
  '#949fe6',
  '#a7b0ec',
  '#c5cbfc',
  '#cad1f8',
  '#e1ecfc'
];

const contributorColors = [
  '#0083d9',
  '#00aaef',
  '#006fcc',
  '#7260ca',
  '#0097e5',
  '#005bbd',
  '#00bdf7',
  '#5cd6ff',
  '#8246b3',
  '#43c5fd',
  '#35b3fa',
  '#3aa1f3',
  '#4b8dea',
  '#0047ab',
  '#5f77dc',
];

const shortColors = [
  '#006fcc',
  '#0097e5',
  '#00bdf7',
  '#4b8dea',
  '#0047ab'
];

const pictorialColors = [
  '#6369bd',
  '#d80b9a',
  '#C6E579',
  '#9e0400',
  '#61a0a8',
  '#d48265',
  '#2f4554',
  '#f39c12',
  '#91c7ae',
  '#bda29a',
  '#749f83',
  '#6e7074',
  '#546570',
  '#c4ccd3'
];

const distributionColors = [
  '#ff0000',
  '#a7b0ec',
  '#e5a352',
  '#9e0400',
  '#45e17c',
]

const commitsChartColors = [
  '#E0E8EE',
  '#f39c12',
  '#0047ab'
];

const statusColors = [
  '#9e0400',
  '#e74c3c',
  '#f39c12',
  '#1dd761'
];

const effColors = [
  '#6369bd',
  '#d80b9a',
  '#C6E579',
  '#9e0400',
  '#61a0a8',
  '#d48265',
  '#2f4554',
  '#f39c12',
  '#2ca469',
  '#e58a70',
  '#0d5427',
  '#0c44bd',
  '#1598f3',
  '#5622b6',
  '#b23b1a',
  '#4bb972',
  '#4a618d',
  '#15f3f3',
  '#2c0075',
  '#484747',
  '#7c5e30',
  '#46578d',
  '#96822c',
  '#544b28',
  '#61a21c',
  '#af2b66',
  '#ab6b20',
  '#7c6815',
  '#2a7e77',
  '#355ab4',
  '#1a145e',
  '#af720e',
  '#4473b4',
  '#ffa734',
];

const [ first, ...args ] = statusColors;

const colorMap = new Map([
  ['default', defaultColors],
  ['short', shortColors],
  ['pictorial', pictorialColors],
  ['distribution', distributionColors],
  ['commits', commitsChartColors],
  ['status', statusColors],
  ['contributor', contributorColors],
  ['progress', progressColors],
  ['gitwiser-summary', args],
  ['effColors', effColors]
]);

export default colorMap;
